/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { ClearTelemetryModal } from '@/pages/Telemetry/ClearTelemetryModal';

export default function ClearTelemetryPage() {
  return <ClearTelemetryModal />;
}
